import { Inject, Provider } from '@angular/core';
import {
  SideMenuAction,
  SIDE_MENU_ACTIONS,
  DEFAULT_SIDEMENU_TITLE,
  SideMenuService
} from '@pcplus/infrastructure';
import { combineLatest, of, ReplaySubject, zip } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { AuthenticationService } from './services/authentication/authentication.service';
import { Permission } from './dto/permission';
import { PermissionsService } from './services/permissions/permissions.service';
import { EmptyGuid } from './dto/security-identifiers';

export const sideMenuSecurityProvider = [
  {
    provide: SIDE_MENU_ACTIONS,
    useFactory: (perm: PermissionsService, sideMenu: SideMenuService) => {
      const sub = new ReplaySubject<SideMenuAction[]>(1);
      const actions = sideMenu.sideMenuActions.slice();
      const observables = actions.map((action: SideMenuAction) => {
        if (action.adminOnly) {
          return perm.isAdministrator();
        } else {
          if (action.activity && action.activity.length > 0) {
            return perm.hasAnyPermission(
              [Permission.Read, Permission.Allow],
              action.activity
            );
          } else {
            return perm.currentCustomer.pipe(map((cu) => cu !== EmptyGuid));
          }
        }
      });
      combineLatest(observables).subscribe((values) => {
        const emit: SideMenuAction[] = new Array<SideMenuAction>();
        for (let i = 0; i < actions.length; i++) {
          if (values[i]) {
            emit.push(actions[i]);
          }
        }
        sub.next(emit);
      });
      return sub;
    },
    deps: [PermissionsService, SideMenuService]
  },
  {
    provide: DEFAULT_SIDEMENU_TITLE,
    useFactory: (auth: AuthenticationService) => auth.currentUser$,
    deps: [AuthenticationService]
  }
];
